import React, { useContext } from "react";
import { Segment, Button, Icon } from "semantic-ui-react";
import ListUsers from "./ListUsers";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import CreateUserForm from "./CreateUserForm";
import BreadcrumbContainer from "../../../../app/common/breadcrumb/BreadcrumbContainer";

interface IProps {
  sections: any[];
}

const DashboardUsers: React.FC<IProps> = ({ sections }) => {
  const rootStore = useContext(RootStoreContext);
  const { openModal } = rootStore.modalStore;

  document.title = "Usuarios";
  return (
    <div className="configurationContent">
      <BreadcrumbContainer title="Usuarios" sections={sections} />
      <Segment >
        <Button
          onClick={() => openModal(<CreateUserForm />, "Crear usuario")}
          color="blue"
        >
          <Icon name="add user" /> Agregar Usuario
        </Button>
        <br />
        <br />
        <ListUsers />
      </Segment>
    </div>
  );
};

export default DashboardUsers;
